var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-avatar',{staticClass:"primary lighten-2 white--text headline mr-2 font-weight-bold",attrs:{"size":"29"}},[_vm._v(" "+_vm._s(_vm.year)+" ")]),_c('span',{staticClass:"d-none d-lg-inline"},[_vm._v(" "+_vm._s(_vm.scholasticYearFormatted)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }